import { render, staticRenderFns } from "./FlexCard.vue?vue&type=template&id=099b7cbe&"
import script from "./FlexCard.vue?vue&type=script&lang=ts&"
export * from "./FlexCard.vue?vue&type=script&lang=ts&"
import style0 from "./FlexCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports